import { UserModule } from '@/store/modules/user';
import { WorkbenchLayoutModules } from '@/store/modules/workBenchServicer';
import { Type } from '@/types/permissionType';
import { checkPermissionCompany, checkPermissionUseAndCompany } from './permission';
const layout: any = [
  {
    'i': '0',
    'x': 0,
    'y': 0,
    'w': 9,
    'h': 6,
    name: '所有工单',
    type: '1',
    isDiy: true,
    permission: ''
  }, {
    'i': '1',
    'x': 9,
    'y': 0,
    'w': 3,
    'h': 2,
    name: '当前版本',
    type: '2',
    isDiy: false,
    permission: ''
  }, {
    'i': '2',
    'x': 9,
    'y': 0,
    'w': 3,
    'h': 4,
    name: '留言投诉',
    type: '3',
    isDiy: true,
    permission: ''
  }, {
    'i': '3',
    'x': 0,
    'y': 0,
    'w': 9,
    'h': 4,
    name: '最近待办工单',
    type: '4',
    isDiy: true,
    permission: ''
  }, {
    'i': '4',
    'x': 9,
    'y': 0,
    'w': 3,
    'h': 4,
    name: '巡检情况',
    type: '5',
    isDiy: true,
    permission: Type.EORDER_POLLING
  }, {
    'i': '5',
    'x': 0,
    'y': 0,
    'w': 9,
    'h': 4,
    name: '部门订单排行榜',
    type: '6',
    isDiy: true,
    permission: Type.StaffDepatment
  }, {
    'i': '6',
    'x': 9,
    'y': 0,
    'w': 3,
    'h': 4,
    name: '巡检任务',
    type: '7',
    isDiy: true,
    permission: Type.EORDER_POLLING
  }, {
    'i': '7',
    'x': 0,
    'y': 0,
    'w': 9,
    'h': 4,
    name: '设备故障分析 TOP10',
    type: '8',
    isDiy: true,
    permission: Type.device
  }, {
    'i': '8',
    'x': 9,
    'y': 0,
    'w': 3,
    'h': 6,
    name: '工程师任务排行榜',
    type: '9',
    isDiy: true,
    permission: '',
  }, {
    'i': '9',
    'x': 0,
    'y': 0,
    'w': 9,
    'h': 6,
    name: '故障现象订单统计',
    type: '10',
    isDiy: true,
    permission: Type.FAULT_PHENOMENON + ',' + Type.fault,
    moduleList: [
      {
        id: 1,
        name: '故障现象订单统计',
        permission: Type.FAULT_PHENOMENON,
        show: false,
        isCopanyPermission: false,
      },
      {
        id: 2,
        name: '故障类型订单统计',
        permission: Type.fault,
        show: false,
        isCopanyPermission: false,
      },
    ]
  }, {
    'i': '10',
    'x': 9,
    'y': 0,
    'w': 3,
    'h': 4,
    name: '更新迭代',
    type: '11',
    isDiy: true,
    permission: ''
  }
];
export function returnLayout() {
  let lLayout:any = [];
  layout.forEach((val:any) => {
    if (val.moduleList && val.moduleList.length > 0) {
      val.moduleList.forEach((val:any) => {
        if (val.permission) {
          if (val.isCopanyPermission) {
            val.show = checkPermissionCompany(UserModule.getCompanyId, parseInt(val.permission));
          } else {
            val.show = checkPermissionUseAndCompany(UserModule.getCompanyId, parseInt(val.permission));
          }
        }
      });
    }
    if (val.permission) {
      let p = String(val.permission).split(',');
      let arr = p.filter((element:any) => {
        return checkPermissionCompany(UserModule.getCompanyId, parseInt(element))
      })
      if (arr && arr.length > 0) {
        lLayout.push(val);
      }
    } else {
      lLayout.push(val);
    }
  });
  // WorkbenchLayoutModules.setLayout(lLayout);
  return lLayout;
}
export function returnPamars(layout:any) {
  let pamars:any = {};
  let lLayout:any = layout;
  lLayout.forEach((val:any) => {
    switch (parseInt(val.type)) {
      case 1:
        pamars.is_order_information = 1;
        break;
      case 2:
        pamars.is_company_version_information = 1;
        break;
      case 3:
        pamars.is_order_bbs_information = 1;
        break;
      case 4:
        pamars.is_unfinish_order_information = 1;
        break;
      case 5:
        pamars.is_today_order_polling_information = 1;
        break;
      case 6:
        if (checkPermissionCompany(UserModule.getCompanyId, Type.StaffDepatment)) {
          pamars.is_department_order_ranking = 1;
        } else {
          if (checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY)) {
            pamars.is_customer_order_ranking = 1;
          }
        }
        break;
      case 7:
        pamars.is_order_polling_task_information = 1;
        break;
      case 8:
        pamars.is_device_ranking = 1;
        break;
      case 9:
        pamars.is_engineer_ranking = 1;
        break;
      case 10:
        if (checkPermissionCompany(UserModule.getCompanyId, Type.fault) && !checkPermissionCompany(UserModule.getCompanyId, Type.FAULT_PHENOMENON)) {
          pamars.is_fault_type_statistics = 1;
        } else {
          pamars.is_fault_phenomenon_statistics = 1;
        }
        break;
    }
  });
  return pamars;
}
